module.exports = __webpack_public_path__ + "static/media/galerija_2022_0056.288b7108.jpg";